import { render, staticRenderFns } from "./TableColumnModal.vue?vue&type=template&id=21f11190&scoped=true"
import script from "./TableColumnModal.vue?vue&type=script&lang=js"
export * from "./TableColumnModal.vue?vue&type=script&lang=js"
import style0 from "./TableColumnModal.vue?vue&type=style&index=0&id=21f11190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f11190",
  null
  
)

export default component.exports